var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPuntoLimpio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 65",
    style: {
      enableBackground: "new 0 0 50 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#72BA51;}\n\t.st1{fill:#0E8E35;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    className: "st0",
    d: "M109.9,15.6h-0.2l-3.1-12.3c0,0,0-0.1,0-0.1c-0.6-1.5-2-2.5-3.6-2.5H75.1 c-1.6,0.1-3,1-3.6,2.5c0,0,0,0.1,0,0.1l-3.1,12.3h-0.2c-1.6,0-3,1.3-3,3v4c0,1.3,0.8,2.4,2,2.8v34c0,2.7,2.2,5,5,5h33.8 c2.7,0,5-2.2,5-5v-34c1.2-0.4,2-1.5,2-2.8v-4C112.9,16.9,111.5,15.6,109.9,15.6L109.9,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    className: "st0",
    d: "M109.7,15.6l-3.1-12.3c0,0,0-0.1,0-0.1c-0.6-1.5-2-2.5-3.6-2.5H75.1c-1.6,0.1-3,1-3.6,2.5 c0,0,0,0.1,0,0.1l-3.1,12.3L109.7,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    className: "st1",
    d: "M109.9,15.6H68.1c-1.6,0-3,1.3-3,3v4c0,1.6,1.3,3,3,3h41.8c1.6,0,3-1.3,3-3v-4 C112.9,16.9,111.5,15.6,109.9,15.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    transform: "translate(76.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    className: "st1",
    d: "M1.1,0.7v8c0,1.1,0.9,2,2,2H21c1.1,0,2-0.9,2-2v-8H1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    transform: "translate(53.391 -4.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    className: "st1",
    d: "M26.6,57.9c0.6,0.2,1.2,0.1,1.6-0.3l0.6-0.6c0.3,0.3,0.5,0.5,0.8,0.7c1.8,1.3,4,2,6.2,2 c5,0.1,9.3-3.5,10-8.4c0.1-0.8-0.5-1.6-1.3-1.7s-1.6,0.5-1.7,1.3l0,0c-0.5,3.4-3.5,5.9-7,5.7c-1.6,0-3.1-0.5-4.4-1.4 c-0.1-0.1-0.3-0.2-0.4-0.3l1-0.9c0.6-0.6,0.6-1.5,0.1-2.1c-0.3-0.3-0.7-0.5-1.1-0.5h-3.8c-0.8,0-1.5,0.7-1.5,1.5v3.5 C25.7,57.2,26.1,57.7,26.6,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    className: "st1",
    d: "M27.1,49.7c0.1,0,0.1,0,0.2,0c0.8,0,1.4-0.6,1.5-1.3c0.5-3.4,3.5-5.9,7-5.7 c1.6,0,3.1,0.5,4.4,1.4c0.1,0.1,0.3,0.2,0.4,0.3l-1,0.9c-0.6,0.6-0.6,1.5-0.1,2.1c0.3,0.3,0.7,0.5,1.1,0.5h3.8 c0.8,0,1.5-0.7,1.5-1.5v-3.5c0-0.8-0.7-1.5-1.5-1.5c-0.4,0-0.8,0.1-1,0.4l-0.6,0.6c-0.3-0.3-0.5-0.5-0.8-0.7c-1.8-1.3-4-2-6.2-2 c-5-0.1-9.3,3.5-10,8.4C25.6,48.9,26.2,49.6,27.1,49.7C27.1,49.7,27.1,49.7,27.1,49.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPuntoLimpio);
export default __webpack_public_path__ + "static/media/icon-punto-limpio.71ee8a5c513b8a5be3bd61e759a6ffcc.svg";
export { ForwardRef as ReactComponent };